module.exports = __webpack_public_path__ + "static/media/band.4e56bdba.svg";